import React from 'react';
import { Link } from '@/components/atoms/Link/render';

// Helper function to render title with dangerouslySetInnerHTML
const renderTitle = (
	content: string,
	className: string,
	tag: 'h3' | 'p' = 'h3'
) => {
	const Component = tag;
	return (
		<Component
			className={className}
			dangerouslySetInnerHTML={{ __html: content }}
		/>
	);
};

interface CardTitleWithLinkProps {
	linkProps?: {
		href: string;
		attrs?: Record<string, string>;
	} | null;
	artist?: string;
	title?: string;
}

export const CardTitleWithLink: React.FC<CardTitleWithLinkProps> = ({
	linkProps,
	artist,
	title,
}) => {
	if (linkProps) {
		if (artist && title) {
			return (
				<>
					<Link
						className="supt-cardShow__link"
						href={linkProps.href}
						{...linkProps.attrs}
					>
						{renderTitle(artist, 'supt-cardShow__artist')}
					</Link>
					{renderTitle(title, 'supt-cardShow__title', 'p')}
				</>
			);
		}
		if (artist) {
			return (
				<Link
					className="supt-cardShow__link"
					href={linkProps.href}
					{...linkProps.attrs}
				>
					{renderTitle(artist, 'supt-cardShow__artist')}
				</Link>
			);
		}

		// Only title, no artist
		return (
			<Link
				className="supt-cardShow__link"
				href={linkProps.href}
				{...linkProps.attrs}
			>
				{renderTitle(title, 'supt-cardShow__title')}
			</Link>
		);
	}

	if (artist) {
		return (
			<>
				{renderTitle(artist, 'supt-cardShow__artist')}
				{title && renderTitle(title, 'supt-cardShow__title', 'p')}
			</>
		);
	}

	return renderTitle(title, 'supt-cardShow__title');
};
